import React from "react";
import i18n from "@/utils/i18n";
import ErrorPage from "./ErrorPage";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/** Global render-error fallback. Herhangi bir bileşen throw ederse beyaz ekran yerine
 *  kullanıcıya anlamlı bir hata sayfası göster; "Ana Sayfaya Dön" butonu app'i resetler. */
export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error("[ErrorBoundary]", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          errorCode="!"
          titleKey="errors.unexpected.title"
          titleDefault={i18n.t("errorBoundary.title")}
          descriptionKey="errors.unexpected.description"
          descriptionDefault={i18n.t("errorBoundary.description")}
          buttonKey="errors.notFound.goToDashboard"
          buttonDefault={i18n.t("errorBoundary.button")}
        />
      );
    }
    return this.props.children;
  }
}
